import useMeQuery from "@/hooks/use-me-query";
import { FC, ReactNode } from "react";
import { Outlet } from "react-router";

const ProtectedGuard: FC<{ children?: ReactNode }> = ({ children }) => {
  useMeQuery();

  return children ?? <Outlet />;
};

export default ProtectedGuard;
